import { backendURL } from "../utils/constants/constants";

export async function getListCurrencies() {

    try {
        const response = await fetch(`${backendURL}/exchangeRate/listCurrency`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();

        return data;
    } catch (e) {
        throw (e);
    }
}

export async function getConvertCurrency({ amount }) {

    try {
        const response = await fetch(`${backendURL}/exchangeRate/convert?amount=${amount}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        const data = await response.json();

        return data;
    } catch (e) {
        throw (e);
    }
}